import { useEffect, useState } from "react";

import getTime from "../helpers/getTime";

const useTime = (dateString?: string) => {
  const [now, setNow] = useState<Date>(getTime(dateString));

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(getTime(dateString));
    }, 60000);

    return () => clearInterval(interval);
  }, [dateString]);

  return now;
};

export default useTime;
